import React, { useState } from "react";
import Index from "./../../container/Index";
import PagesIndex from "../PagesIndex";

const ShowTicketCalculation = ({ bookingDetails, finalBookingCalculation }) => {
  const [openTicketCartGST, setOpenTicketCartGST] = useState(false);
  const [openFoodCartGST, setOpenFoodCartGST] = useState(false);

  const handleTicketCartGSTToolTip = () => {
    setOpenTicketCartGST(!openTicketCartGST);
  };
  const handleFoodCartGSTToolTip = () => {
    setOpenFoodCartGST(!openFoodCartGST);
  };


  return (
    <Index.Accordion>
      <Index.AccordionSummary
        expandIcon={<Index.ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Index.Typography
          variant="p"
          component="p"
          className="booking-detail-label"
        >
          Total Amount
        </Index.Typography>
        <Index.Typography
          variant="p"
          component="p"
          className="booking-detail-value"
        >
          ₹
          {/* {parseFloat(
            typeof bookingDetails?.paymentResponse?.amount === "string"
              ? bookingDetails?.paymentResponse?.amount
              : bookingDetails?.paymentResponse?.amount / 100 || 0
          ).toFixed(2)} */}
          {parseFloat(
            bookingDetails?.finalBookingCalculation?.finalAmount
              ? bookingDetails?.finalBookingCalculation?.finalAmount
              : bookingDetails?.paymentResponse?.amount
          ).toFixed(2)}
        </Index.Typography>
      </Index.AccordionSummary>
      <Index.AccordionDetails className="show-booking-details">
        <Index.Box className="ticket-flex-gst">
          <Index.Box className="ticket-details-book-confirm">
            <Index.Typography
              variant="p"
              component="p"
              className="booking-detail-label bold-confirmation"
            >
              Ticket Price :
            </Index.Typography>
            <Index.Typography
              variant="p"
              component="p"
              className="booking-detail-value bold-confirmation"
            >
              ₹
              {finalBookingCalculation?.ticketCart?.ticketTotal
                ? parseFloat(
                  finalBookingCalculation?.ticketCart?.ticketTotal
                ).toFixed(2)
                :"0.00"}
            </Index.Typography>
          </Index.Box>
           {finalBookingCalculation &&
          Object.keys(finalBookingCalculation).length > 0 ? (
            <>
              {finalBookingCalculation?.ticketCart?.membershipDiscount || finalBookingCalculation?.foodCart?.membershipDiscount  ? (
                <Index.Box className="payment-summary-row">
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="payment-summary-label"
                  >
                    Membership Discount :
                  </Index.Typography>
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="payment-summary-value"
                  >
                    {
                      parseFloat(
                        (Number(finalBookingCalculation?.ticketCart?.membershipDiscount) || 0) +
                        (Number(finalBookingCalculation?.foodCart?.membershipDiscount) || 0)
                      ).toFixed(2)
                    }
                  </Index.Typography>
                </Index.Box>
              ) : (
                ""
              )}

              {finalBookingCalculation?.ticketCart?.discountAmount || finalBookingCalculation?.foodCart?.discountAmount ? (
                <Index.Box className="payment-summary-row">
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="payment-summary-label"
                  >
                    Discount :
                  </Index.Typography>
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="payment-summary-value"
                  >
                    ₹
                    {
                      parseFloat(
                        (Number(finalBookingCalculation?.ticketCart?.discountAmount) || 0) +
                        (Number(finalBookingCalculation?.foodCart?.discountAmount) || 0)
                      ).toFixed(2)
                    }
                  </Index.Typography>
                </Index.Box>
              ) : (
                ""
              )}

               {/* {finalBookingCalculation?.ticketCart?.totalAfterDiscount ? (
                <Index.Box className="payment-summary-row">
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="payment-summary-label"
                  >
                    Total After Discount :
                  </Index.Typography>
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="payment-summary-value"
                  >
                    ₹
                    {finalBookingCalculation?.ticketCart?.totalAfterDiscount
                      ? parseFloat(
                          finalBookingCalculation?.ticketCart
                            ?.totalAfterDiscount
                        )?.toFixed(2)
                      : 0}
                  </Index.Typography>
                </Index.Box>
              ) : (
                ""
              )}  */}
            {/*
              <Index.Box className="payment-summary-row name-w-100">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="payment-summary-label flex-gst-details"
                >
                  GST
                  <Index.ClickAwayListener
                    // onClickAway={handleTicketCartGSTToolTip}
                    className="tooltip-click-away"
                  >
                    <div>
                      <Index.Tooltip
                        PopperProps={{
                          disablePortal: true,
                        }}
                        onClose={handleTicketCartGSTToolTip}
                        open={openTicketCartGST}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        arrow="center"
                        placement="right"
                        className="tooltip-open-btn"
                        title={
                          <div className="tooltip-inner-details">
                            <Index.Box className="name-w-100">
                              <Index.Typography
                                variant="p"
                                component="p"
                                className="payment-summary-label"
                              >
                                CGST (
                                {finalBookingCalculation?.ticketCart
                                  ?.totalAfterDiscount < 115
                                  ? `6%`
                                  : "9%"}
                                )
                              </Index.Typography>
                            </Index.Box>
                            <Index.Box className="name-w-100">
                              <Index.Typography
                                variant="p"
                                component="p"
                                className="payment-summary-label"
                              >
                                SGST (
                                {finalBookingCalculation?.ticketCart
                                  ?.totalAfterDiscount < 115
                                  ? `6%`
                                  : "9%"}
                                )
                              </Index.Typography>
                            </Index.Box>
                          </div>
                        }
                      >
                        <Index.Button
                          onClick={handleTicketCartGSTToolTip}
                          className="handal-btn-tool"
                        >
                          <img
                            src={PagesIndex.Png.informationButton}
                            className="information-icon"
                          />
                        </Index.Button>
                      </Index.Tooltip>
                    </div>
                  </Index.ClickAwayListener>
                </Index.Typography>
                <Index.Typography
                  variant="p"
                  component="p"
                  className="payment-summary-value"
                >
                  {parseFloat(
                    finalBookingCalculation?.ticketCart?.cgst +
                      finalBookingCalculation?.ticketCart?.sgst
                  ).toFixed(2) !== "NaN"
                    ? `₹${parseFloat(
                        finalBookingCalculation?.ticketCart?.cgst +
                          finalBookingCalculation?.ticketCart?.sgst
                      ).toFixed(2)}`
                    : 0}
                </Index.Typography>
              </Index.Box>

              <Index.Box>
                <Index.Typography
                  variant="p"
                  component="p"
                  className="booking-detail-label"
                >
                  Sub Total :
                </Index.Typography>
                <Index.Typography
                  variant="p"
                  component="p"
                  className="booking-detail-value "
                >
                  ₹
                  {finalBookingCalculation?.ticketCart?.total
                    ? parseFloat(
                        finalBookingCalculation?.ticketCart?.total
                      )?.toFixed(2)
                    : 0}
                 </Index.Typography>
            </Index.Box> */}
            </>
          ) :""}
      </Index.Box>

        {bookingDetails?.fAndBDetails?.length ? (
          <Index.Box className="confirm-space-ticket">
            <Index.Box className="food-confrimation-details">
              <Index.Box className="coupon-title-screen ticket-details-book-confirm w-100-full">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="booking-detail-label bold-confirmation"
                >
                  Foods & Beverages:
                </Index.Typography>
                <Index.Typography
                  variant="p"
                  component="p"
                  className="booking-detail-value bold-confirmation"
                >
                  ₹
                    {finalBookingCalculation?.foodCart?.fnbTotal
                    ? parseFloat(finalBookingCalculation?.foodCart?.fnbTotal).toFixed(2)
                    : 0}
                  {/* {finalBookingCalculation?.foodCart?.total
                    ? parseFloat(finalBookingCalculation?.foodCart?.total).toFixed(2)
                    : 0} */}
                </Index.Typography>
              </Index.Box>

              {bookingDetails?.fAndBDetails?.map((data, key) => (
                <Index.Box
                  className="food-list-item coupon-food-couple"
                  key={key}
                >
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="booking-detail-label"
                  >
                    {data?.name.toLowerCase()}{" "}
                    <small>(x{data?.quantity})</small>
                  </Index.Typography>
                  <Index.Typography
                    variant="p"
                    component="p"
                    className="booking-detail-label"
                  >
                    ₹{parseFloat(data?.price).toFixed(2)}
                  </Index.Typography>
                </Index.Box>
              ))}

              {/* <Index.Box className="name-w-100">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="booking-detail-label bold-confirmation"
                >
                  Food & Beverages Amount:
                </Index.Typography>
                <Index.Typography
                  variant="p"
                  component="p"
                  className="booking-detail-value bold-confirmation"
                >
                  ₹
                  {finalBookingCalculation?.foodCart?.basePrice
                    ? parseFloat(finalBookingCalculation?.foodCart?.basePrice).toFixed(2)
                    : 0}
                </Index.Typography>
              </Index.Box> */}

              {/* {finalBookingCalculation &&
                Object.keys(finalBookingCalculation).length > 0 && (
                  <>
                    {finalBookingCalculation?.foodCart?.membershipDiscount && (
                      <Index.Box className="payment-summary-row name-w-100">
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="payment-summary-label"
                        >
                          Membership Discount:
                        </Index.Typography>
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="payment-summary-value"
                        >
                          ₹{parseFloat(finalBookingCalculation?.foodCart?.membershipDiscount)?.toFixed(2) || 0}
                        </Index.Typography>
                      </Index.Box>
                    )}

                    {finalBookingCalculation?.foodCart?.discountAmount && (
                      <Index.Box className="payment-summary-row name-w-100">
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="payment-summary-label"
                        >
                          Discount:
                        </Index.Typography>
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="payment-summary-value"
                        >
                          ₹{parseFloat(finalBookingCalculation?.foodCart?.discountAmount)?.toFixed(2) || 0}
                        </Index.Typography>
                      </Index.Box>
                    )}

                    {finalBookingCalculation?.foodCart?.totalAfterDiscount && (
                      <Index.Box className="name-w-100 payment-summary-row">
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="payment-summary-label"
                        >
                          Total After Discount:
                        </Index.Typography>
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="payment-summary-value"
                        >
                          ₹{parseFloat(finalBookingCalculation?.foodCart?.totalAfterDiscount)?.toFixed(2) || 0}
                        </Index.Typography>
                      </Index.Box>
                    )}

                    <Index.Box className="payment-summary-row name-w-100">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="payment-summary-label flex-gst-details"
                      >
                        GST
                        <Index.ClickAwayListener className="tooltip-click-away">
                          <div>
                            <Index.Tooltip
                              PopperProps={{ disablePortal: true }}
                              onClose={handleFoodCartGSTToolTip}
                              open={openFoodCartGST}
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener
                              arrow="center"
                              placement="right"
                              className="tooltip-open-btn"
                              title={
                                <div className="tooltip-inner-details">
                                  <Index.Box className="name-w-100">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="booking-detail-label"
                                    >
                                      CGST (2.5%)
                                    </Index.Typography>
                                  </Index.Box>
                                  <Index.Box className="name-w-100">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="booking-detail-label"
                                    >
                                      SGST (2.5%)
                                    </Index.Typography>
                                  </Index.Box>
                                </div>
                              }
                            >
                              <Index.Button
                                onClick={handleFoodCartGSTToolTip}
                                className="handal-btn-tool"
                              >
                                <img
                                  src={PagesIndex.Png.informationButton}
                                  className="information-icon"
                                />
                              </Index.Button>
                            </Index.Tooltip>
                          </div>
                        </Index.ClickAwayListener>
                      </Index.Typography>
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="payment-summary-value"
                      >
                        ₹
                        {parseFloat(
                          finalBookingCalculation?.foodCart?.cgst +
                          finalBookingCalculation?.foodCart?.sgst
                        ).toFixed(2) || 0}
                      </Index.Typography>
                    </Index.Box>

                    <Index.Box className="name-w-100">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="booking-detail-label"
                      >
                        Sub Total:
                      </Index.Typography>
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="booking-detail-value"
                      >
                        ₹{parseFloat(finalBookingCalculation?.foodCart?.total)?.toFixed(2) || 0}
                      </Index.Typography>
                    </Index.Box>
                  </>
                )} */}
            </Index.Box>
          </Index.Box>
        ) : null}

        {/* <Index.Box className="coupon-code-details">
                        <Index.Box className="coupon-title-screen">
                          <Index.Typography
                            variant="p"
                            component="p"
                            className="booking-detail-label bold-confirmation"
                          >
                            Coupon :
                          </Index.Typography>
                        </Index.Box>
                        <Index.Box className="coupon-details">
                          <Index.Typography
                            variant="p"
                            component="p"
                            className="booking-detail-label"
                          >
                  <span>Coupon Title : </span> CNPX - 0000030
                          </Index.Typography>
                          <Index.Typography
                            variant="p"
                            component="p"
                            className="booking-detail-value"
                          >
                            ₹ 200
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box> */}

        {/*<Index.Box>
           <Index.Typography
            variant="p"
            component="p"
            className="booking-detail-label"
          >
            Service Charge :
          </Index.Typography>
          <Index.Typography
            variant="p"
            component="p"
            className="booking-detail-value"
          >
            ₹ 0.00
          </Index.Typography>
        </Index.Box> */}

        <Index.Box>
          <Index.Typography
            variant="p"
            component="p"
            className="booking-detail-label"
          >
            Convenience fee <small>(Including GST)</small> :
          </Index.Typography>
          <Index.Typography
            variant="p"
            component="p"
            className="booking-detail-value"
          >
            ₹
            {finalBookingCalculation?.convenienceFeesObject?.total > 0 ? parseFloat(
              finalBookingCalculation?.convenienceFeesObject?.total
            ).toFixed(2) : "0.00"}
          </Index.Typography>
        </Index.Box>

        {/* <Index.Box className="coupon-listing-screen">
                        <Index.Box className="coupon-title-details">
                          <Index.Typography>Coupon Code</Index.Typography>
                        </Index.Box>
                          <Index.Box className="coupon-flex-screen">
                            <Index.Typography
                              variant="p"
                              component="p"
                              className="booking-detail-label"
                            >
                              CNPX - 0000030
                            </Index.Typography>
                            <Index.Typography
                              variant="p"
                              component="p"
                              className="booking-detail-value"
                            >
                              ₹ 1000
                            </Index.Typography>
                          </Index.Box>
                      
                      </Index.Box> */}
      </Index.AccordionDetails>
    </Index.Accordion>
  );
};

export default ShowTicketCalculation;
